import {
  type AnyMenuItem,
  MENU_ITEM_TYPE,
} from 'app/modules/Navigation/types';

import { getSportKey } from 'app/lib/betting/sport-utils';

export type MenuItemTestDataAttributes = {
  'data-test': string;
  'data-test-item-type': string;
  'data-test-item-key': string;
  'data-test-item-active'?: 'active';
};

export const createMenuItemTestDataAttributesGetter = (
  menuItemFamily: string,
  layerSpecificType: MENU_ITEM_TYPE,
) => (item: AnyMenuItem): MenuItemTestDataAttributes => {
  const attributes: MenuItemTestDataAttributes = {
    'data-test': menuItemFamily,
    'data-test-item-type': '',
    'data-test-item-key': '',
  };

  switch (item.type) {
    case MENU_ITEM_TYPE.SPORT:
      attributes['data-test-item-type'] = item.type;
      attributes['data-test-item-key'] = getSportKey(item.sportId);
      break;

    case MENU_ITEM_TYPE.CONSTANT:
    case layerSpecificType:
      attributes['data-test-item-type'] = item.type;
      attributes['data-test-item-key'] = item.key;
      break;

    default:
      attributes['data-test-item-type'] = `promoted-${item.type}`;
      attributes['data-test-item-key'] = item.key;
      break;
  }

  if (item.active) {
    attributes['data-test-item-active'] = 'active';
  }

  return attributes;
};
